import { Component, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { AgentService, AgentServicesClient, DeliverService, DeliverServicesClient, Kasa, KasaClient, ServiceRequest, TaxesSettlementsDetails, TaxSettlementClient } from "src/app/web-api-client";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { forkJoin, Subject } from "rxjs";
import { WtStorageService } from "../../wt-storage.service";

@Component({
  selector: 'app-create-tax-settlement',
  templateUrl: './create-tax-settlement.component.html',
  styleUrls: ['./create-tax-settlement.component.scss']
})
export class CreateTaxSettlementComponent implements OnInit {

  public isLoaded = false;
  public deliveryServiceOptions: IDeliveryServiceOption[] = [];
  public filteredServiceRequests: ServiceRequest[] = []; // Assume IServiceRequest is already defined
  public selectedBankAccount: string = '';
  public services: ServiceRequest[];
  public deliverServices: DeliverService[] = [];
  public taxSettlements: TaxesSettlementsDetails[] = [];
  public onClose: Subject<void> = new Subject();


  Form: FormGroup;

  constructor(private fb: FormBuilder, public activeModal: NgbActiveModal, public taxSettlementClient: TaxSettlementClient, public deliverServiceClient: DeliverServicesClient, public wtStore: WtStorageService, public client: KasaClient) { }

  ngOnInit() {

    this.loadData();

  }

  private loadData() {
    this.isLoaded = false;
    forkJoin([this.deliverServiceClient.getAllItems(), this.taxSettlementClient.getList()]).subscribe(([deliverService, taxSettlement]) => {

      this.deliverServices = deliverService.filter(d=>d.bankDetails);
      this.taxSettlements = taxSettlement;

      this.services = this.services.filter(d => !this.taxSettlements.find(r => r.idServiceRequest == d.idServiceRequest));
      this.loadDeliveryServiceOptions();
      this.isLoaded = true;
    });
  }

  loadDeliveryServiceOptions() {

    this.deliveryServiceOptions = this.services
      // First, map to get the necessary properties
      .map(service => {
        const deliver = this.deliverServices.find(d => d.idDeliversService === service.idDeliversService);
        return deliver ? {
          bankAccount: deliver.bankDetails.iban,
          serviceName: service.deliverService.serviceProvider.serviceProviderName,
          idDeliversService: service.idDeliversService
        } : undefined;
      })
      // Filter out any undefined entries
      .filter(d => d !== undefined)
      // Use a reduce function to filter out duplicates
      .reduce((unique, o) => {
        if (!unique.some(obj => obj.bankAccount === o.bankAccount && obj.serviceName === o.serviceName)) {
          unique.push(o);
        }
        return unique;
      }, []);

  }

  onBankAccountChange(bankAccount: string) {
    this.selectedBankAccount = bankAccount;
    this.filterServiceRequests({ bankAccount });
  }

  filterServiceRequests(filter: IServiceRequestFilter) {

    let filteredDeliveriServices = this.deliverServices.filter(r => r.bankDetails.iban == filter.bankAccount);
    this.filteredServiceRequests = this.services.filter(r => filteredDeliveriServices.find(s => s.idDeliversService == r.idDeliversService));
  }

  filterServiceRequestsByIndex(index: number) {
    let filter = this.deliveryServiceOptions[index];

    let filteredDeliveriServices = this.deliverServices.filter(r => r.bankDetails.iban == filter.bankAccount);
    return this.filteredServiceRequests = this.services.filter(r => filteredDeliveriServices.find(s => s.idDeliversService == r.idDeliversService));

  }
  createSettlement() {



      this.taxSettlementClient.create().subscribe(d => {

        this.filteredServiceRequests = [];
        this.closeModal();

      })

  }

  getServiceName(serviceRequest: ServiceRequest) {

    let deliveryService = this.deliverServices.find(d => d.idDeliversService == serviceRequest.idDeliversService);
    return deliveryService.title
  }

  closeModal() {
    this.onClose.next();
    this.activeModal.close();
  }

}



export interface IDeliveryServiceOption {
  bankAccount: string;
  serviceName: string;
  idDeliversService: number;
}

export interface IServiceRequestFilter {
  bankAccount: string;
}
